<template>
  <div>
    <portal to="pagination">
      <v-card class="mx-auto" style="max-width:700px">
        <v-alert type="error">
          Ошибка совершения платежа.
        </v-alert>
      </v-card>
    </portal>

    <portal to="footer">
      <v-flex class="d-flex justify-space-between px-5">
        <v-btn color="#009933" outlined tile dark class="my-2" to="/">
          На главную
        </v-btn>
        <v-btn
          color="#009933"
          tile
          :dark="true"
          class="my-2"
          :to="`/signing/${id}/${uid}`"
        >
          К процессу
        </v-btn>
      </v-flex>
    </portal>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },

    computed: {
      id() {
        return this.$route.params.id
      },
      uid() {
        return this.$route.params.uid
      },
    },

    created() {
      this.$store.dispatch('setFooter', true)
    },
  }
</script>
